import { useDispatch, useSelector } from "react-redux";

import type { Topic } from "../types/common";
import { translate } from "app/filters/i18nFilter";
import { setSelectedTopics } from "app/pages/sales-intelligence/sub-modules/intent/store/management/actions/actions";
import { selectIntentSelectedTopics } from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import intentTrackingService from "app/pages/sales-intelligence/services/tracking/intent/trackingService";
import styled from "styled-components";
import { FlexRowFlexEnd } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const StyledItemsButtonCellWrapper = styled(FlexRowFlexEnd)`
    margin-top: 1.5px;
`;

const StyledAddButton = styled.div`
    .SWReactIcons {
        padding: 1px;
        margin-right: 4px;
    }
`;

const withCellComponentIntentAction = (CellComponent) => function(props) {
    const { row }: { row: Topic } = props;
    const dispatch = useDispatch();
    const selectedTopics: readonly Topic[] = useSelector(selectIntentSelectedTopics);
    const isTopicPresent = selectedTopics ? selectedTopics.some((elem) => row.name === elem.name) : false;

    const onAddTopic = (selectedTopic: Topic) => {
        void intentTrackingService.trackAddTopicClickAction(selectedTopic);
        void dispatch(
            setSelectedTopics([
                ...selectedTopics,
                {
                    ...selectedTopic,
                    isNotApplied: true,
                },
            ]),
        );
    };

    const getIconName = () => {
        if (isTopicPresent) {
            return "checked";
        }

        return "plus";
    };

    return (
    <StyledItemsButtonCellWrapper>
        <StyledAddButton>
            <CellComponent
                {...props}
                iconButtonLabel={
                    isTopicPresent ? translate("si.intent.management.btn.added") : translate("si.intent.management.btn.add")
                }
                buttonIconName={getIconName()}
                onClick={() => onAddTopic(row)}
                isDisabled={isTopicPresent}
            />
        </StyledAddButton>
    </StyledItemsButtonCellWrapper>
    );
};

export default withCellComponentIntentAction;
